<template lang="html">

  <section class="intro flex justify-between">
    <img class="w-100 intro-img" src="/static/img/blog/background-encabezado.webp" :alt="$t('blog.alt_images.ajusa_blog')">
    <div class="container flex align-center">
      <img :src="`/static/img/blog/img-logo-${getLanguage}.webp`" :alt="$t('blog.alt_images.puesta_punto')">
    </div>

    <nav class="rrss">
      <li><a class="fa-brands fa-x-twitter" href="https://twitter.com/ajusa_spain?lang=es" target="_blank"></a></li>
      <li><a class="fa fa-facebook" href="https://www.facebook.com/AjusaSpain/" target="_blank"></a></li>
      <li><a class="fa fa-instagram" href="https://www.instagram.com/ajusa_automotive/" target="_blank"></a></li>
      <li><a class="fa fa-youtube" href="https://www.youtube.com/channel/UCnoYVeFbsPiOVOcf80tW6Bg" target="_blank"></a></li>
    </nav>


  </section>
  
</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'blog',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
      ...mapGetters(['getLanguage'])
    }
  }
</script>

<style scoped>

.rrss{
  background: none;
  position: absolute;
  left: 30px;
  bottom: 10px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  -ms-align-items: center;
  align-items: center;
}

.rrss a{
  padding: 10px;
  font-size: 24px;
}

.rrss a:hover{
  color: #054279;
}
li{
  list-style: none;
}

@media screen and (max-width: 768px){

  .container{
    justify-content: center;
    -webkit-justify-content: center;
  }

  .intro .container img{
    max-width: 320px;
  }

}


@media screen and (max-width: 460px){
  
  .intro .container img{
    max-width: 240px;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/blog.vue